import React, { useEffect, useState } from 'react';
import { Button, Form, Input } from 'antd';
import { connect, ConnectedProps } from 'react-redux';
import { Api } from '../../logic/Api/Api';
import { RootState } from '../../logic/store/Store';
import { JSONTreeWithCopy as JSONTree } from '../../components/JSONTreeWithCopy/JSONTreeWithCopy';

/**
 * Present tools to inspect orders that have been sent
 */
const OrderTroubleshootingTool = (props: PropsFromRedux) => 
{
	const [enteredSearchTerm, setEnteredSearchTerm] = useState<string>('');
	const [searchTerm, setSearchTerm] = useState<string>('');
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [orderData, setOrderData] = useState<object>();

	// When a new search term is committed, fetch the order from the server
	useEffect(()=>
	{
		if(!searchTerm)
		{
			return;
		}

		const execute = async () => 
		{
			const api = new Api('/api/6', props.userAuthToken, undefined);
			try
			{
				const response = await api.getAsync<object>(`/supporttools/orders/${encodeURIComponent(searchTerm)}`);	
				setOrderData(response.Data);
			}
			catch(err)
			{
				setOrderData(err);
			}
			setIsLoading(false);
		};
		setIsLoading(true);
		execute();
	},
	[searchTerm, props.userAuthToken]);

	return (
		<Form style={{display:'flex', flexDirection:'column', alignItems:'stretch', height: '100%', position: 'relative'}}>
			<h1>Proposals and Orders</h1>
			<div style={{display: 'flex', flexDirection: 'row', alignItems: 'stretch'}}>
				<Form.Item label="Search term" style={{width: 400, marginRight: 12}}>
					<Input
						disabled={isLoading}
						value={enteredSearchTerm}
						onChange={(e) => setEnteredSearchTerm(e.currentTarget.value)}
						placeholder='Order Number, Salesforce Id, or External Id'
					/>
				</Form.Item>
				<Button onClick={() => setSearchTerm(enteredSearchTerm)}>Search</Button>
			</div>
			<div style={{flexGrow: 1, overflow: 'auto', border: '1px solid #ccc', borderRadius: 4, padding: 8, backgroundColor: '#f6f8fa'}}>
				<JSONTree
					data={orderData}
					theme={'summerfruit'}
					invertTheme={false}
					shouldExpandNodeInitially={() => true}
				/>
			</div>
		</Form>
	);
};

const mapStateToProps = (state: RootState) => ({
	userAuthToken: state.auth.userAuthToken,
});

const connector = connect(mapStateToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

export const OrderTroubleshootingToolComponent = connector(OrderTroubleshootingTool);
